/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  MenuItem,
  Grid,
  TextField,
  FormControl,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import _ from 'lodash';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { AllManufacturer } from './TableHead';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
  REBATE_SELECT,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  validateDateQuarter,       
  fromQtrToDT,                
  toQtrToDT,                  
  autoFormateDate,
  tabHighLigther,
  validateDate,
} from '../../../../SharedModules/utilities/utilities';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  setSearchInput,
  getManufacturerList,
  getResultGridCashSummary,
  setCashReceiptSummaryGrid,
  handleErrorMessagesCRS,
  refreshCashReceiptSummary,
  dispatchReportType,
  getResultGridNonMatCashSummary,
} from '../Store/actions';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import {
  handleScrollToEvent,
  redirectURLLink,
  validDate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';

export default function ReqCashReceiptSummary(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    manufacturerList: resultanufacturerList,
    searchResult,
    isAllManufacturerReducer,
    selectedRowIndexValue,
    selectedReport,
    searchScreenVar: {
      rebateProgramValue,
      selectedPlanType,
      fromDateValue,
      toDateValue,
      allRebateProgram: allRebateProgramValue,
      isAllManufacturersSelected: isAllManufacturersSelectedValue,
      scrollDownManufacturers: scrollDownManufacturersValue,
    },
  } = useSelector((state) => state?.sharedState?.CashReceiptSummaryReducer);
  const errorMessagesFromRedux = useSelector(
    (state) =>
      state?.sharedState?.CashReceiptSummaryReducer?.errorMessagesInRedux
  );
  const searchScreenObj = useSelector(
    (state) => state?.sharedState?.CashReceiptSummaryReducer?.searchScreenVar
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [radioList, setRadioList] = useState([]);
  const [planType, setPlanType] = useState(selectedPlanType);
  const [selectList, setSelectList] = useState([]);
  const [rebateProgram, setRebateProgram] = useState(rebateProgramValue);
  const [rebateProgramName, setRebateProgramName] = useState(
    rebateProgramNameValue
  );

  const [errorList, setErrorList] = React.useState(errors);
  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [toDate, setToDate] = React.useState(toDateValue);
  const [reportType, setReportType] = React.useState(selectedReport);
  const [allRebateProgram, setAllRebateProgram] = React.useState(
    allRebateProgramValue
  );
  const [isAllManufacturersSelected, setIsAllManufacturersSelected] =
    React.useState(isAllManufacturersSelectedValue);

  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [manufacturerSelectedID, setManufacturerSelectedID] =
    React.useState('ALL');
  const [manufacturerSelectedName, setManufacturerSelectedName] =
    React.useState('');
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const [scrollDownManufacturers, setScrollDownManufacturers] = React.useState(
    scrollDownManufacturersValue
  );
  // To know that search button is pressed
  const [isSearchClicked, setSearchClicked] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(
    selectedRowIndexValue
  );
  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
          disabled: allRebateProgram,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList, allRebateProgram]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData?.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list?.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  };
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux && errorMessagesFromRedux.length > 0) {
      tabHighLigther('/cashReceiptSummary', true);
    } else {
      tabHighLigther('/cashReceiptSummary', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
    }
  }, [planType]);

  // To get manufacturer List
  React.useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);

  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultanufacturerList?.rebatePercentOfSpendMfgGridVO);
  }, [resultanufacturerList]);

  // To change the manufacturer grid as per the plan type selection
  const handleOnChangeEvent = (value, name) => {
    if (name === 'planTypeCd') {
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
  };
  const normalizeQuarterPattern = (val = '') => {
    let v = val.trim().toUpperCase().replace(/\s+/g, ''); 
    let m = v.match(/^(20\d{2})Q([1-4])$/);
    if (m) return `${m[2]}Q${m[1]}`; 
    m = v.match(/^Q([1-4])(20\d{2})$/);
    if (m) return `${m[1]}Q${m[2]}`;
    return v;
  };
  const isQuarterToken = (v) => /^[1-4]Q(\d{2}|\d{4})$/.test(v);
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesFromRedux || [];

    const removeFields = (...fields) => {
      fields.forEach((f) => {
        localErr = localErr.filter((e) => e.field !== f);
      });
    };

    if (type === 'rebateProgram') {
      setRebateProgram(value);
      setRebateProgramName(value);
      dispatch(
        refreshCashReceiptSummary({
          ...searchScreenObj,
          rebateProgramValue: value,
          rebateProgramName: value,
        })
      );
      removeFields('rebateProgram', 'resultNotFound');
      if (!value || value === '-1') {
        localErr.push({
          field: 'rebateProgram',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      }
    } else if (type === 'fromDate' || type === 'toDate') {
      const isFrom = type === 'fromDate';
      let raw = (value || '').toUpperCase().trim(); 

      raw = normalizeQuarterPattern(raw); 
      if (isQuarterToken(raw) && /^[1-4]Q\d{2}$/.test(raw)) {
        raw = autoFormateDate(raw); 
      } 
      if (!isQuarterToken(raw) && raw) {
        raw = autoFormateDate(raw);
      }

      if (isFrom) {
        setFromDate(raw);
        dispatch(
          refreshCashReceiptSummary({
            ...searchScreenObj,
            fromDateValue: raw,
          })
        );
      } else {
        setToDate(raw);
        dispatch(
          refreshCashReceiptSummary({
            ...searchScreenObj,
            toDateValue: raw,
          })
        );
      }
      removeFields(
        isFrom ? 'fromDate' : 'toDate',
        'fromDate>toDate',
        'resultNotFound'
      );

      if (!raw) {
        if (isFrom) {
          localErr.push({
            field: 'fromDate',
            errorType: 'formDateRequired',
            message: constantMessageData.FROM_DATE_REQUIRED,
          });
        }
      } else {
        const keyForValidator = isFrom ? 'fromDate' : 'toDate';
        let qtrErrors = validateDateQuarter(raw, keyForValidator) || []; 

        if (qtrErrors.length > 0) {

          localErr = [...localErr, ...qtrErrors];
        } else {
          // If it was NOT a quarter token, and length === full date, 
          if (!isQuarterToken(raw) && raw.includes('/') && raw.length === 10) {
            const invalid =
              validDate(new Date(raw)) === false || !raw.includes('/');
            if (invalid) {
              localErr.push({
                field: isFrom ? 'fromDate' : 'toDate',
                errorType: 'InvalidDate',
                message: isFrom
                  ? constantMessageData.DATE_INVALID_FORMAT_ERROR
                  : constantMessageData.INVALID_DATE_FORMAT,
              });
            }
          }
          if (!isQuarterToken(raw) && raw.includes('/') && raw.length === 10) {
            const invalid =
              validDate(new Date(raw)) === false || !raw.includes('/');
            if (invalid) {
              localErr.push({
                field: isFrom ? 'fromDate' : 'toDate',
                errorType: 'InvalidDate',
                message: isFrom
                  ? constantMessageData.DATE_INVALID_FORMAT_ERROR
                  : constantMessageData.INVALID_DATE_FORMAT,
              });
            }
          } else {
            if (
              !isQuarterToken(raw) &&
              raw.includes('/') &&
              raw.length === 10
            ) {
              const invalid =
                validDate(new Date(raw)) === false || !raw.includes('/');
              if (invalid) {
                localErr.push({
                  field: isFrom ? 'fromDate' : 'toDate',
                  errorType: 'InvalidDate',
                  message: isFrom
                    ? constantMessageData.DATE_INVALID_FORMAT_ERROR
                    : constantMessageData.INVALID_DATE_FORMAT,
                });
              }
            }
          }
        } 

        if (
          isFrom &&
          (!toDate || !toDate.trim()) &&
          !localErr.some((e) => e.field === 'fromDate')
        ) {
          setToDate(raw);
          dispatch(
            refreshCashReceiptSummary({
              ...searchScreenObj,
              fromDateValue: raw,
              toDateValue: raw,
            })
          );
        }
      } 
      const currentFrom = isFrom ? raw : fromDate;
      const currentTo = !isFrom ? raw : toDate;

      const hasFromErr = localErr.some((e) => e.field === 'fromDate');
      const hasToErr = localErr.some((e) => e.field === 'toDate');

      if (currentFrom && currentTo && !hasFromErr && !hasToErr) {
        removeFields('fromDate>toDate'); 
        const concreteFrom = isQuarterToken(currentFrom)
          ? fromQtrToDT(normalizeQuarterPattern(currentFrom))
          : currentFrom;
        const concreteTo = isQuarterToken(currentTo)
          ? toQtrToDT(normalizeQuarterPattern(currentTo))
          : currentTo;

        if (
          compareTwoDatesGreaterThanOrEqual(new Date(concreteTo), concreteFrom)
        ) {
          localErr.push({
            field: 'fromDate>toDate',
            errorType: 'fromDate>toDate',
            message: constantMessageData.TO_DATE_CANT_BE_LESS_THAN_FROM,
          });
        }
      }
    }

    dispatch(
      handleErrorMessagesCRS(
        [...new Set(localErr.map((o) => JSON.stringify(o)))].map((s) =>
          JSON.parse(s)
        )
      )
    );
  };
  // On selection of the row data
  const onSelectionChanged = (e) => {
    e.api.clearFocusedCell();
    const manuError = [];
    const selectedRows = e.api.getSelectedRows();
    setManufacturerSelectedName(selectedRows[0]?.mfgName);
    setManufacturerSelectedID(selectedRows[0]?.mfgId);

    const selectedMfgId = selectedRows?.map((item) => item.mfgId);
    let selectedIndexes = '';
    manufacturerList.forEach((item, index) => {
      if (selectedMfgId?.indexOf(item.mfgId) != -1) {
        selectedIndexes = index;
      }
    });

    setSelectedRowIndex(selectedIndexes);
    setErrorList(manuError);
  };

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen
  const handleSearchClick = (
    e,
    onDoubleClick = false,
    selectedRowOnDoubleClick = []
  ) => {
    let localErr = [];
    const normFrom = normalizeQuarterPattern(fromDate || '');
    const normToRaw = toDate === '' ? fromDate : toDate;
    const normTo = normalizeQuarterPattern(normToRaw || '');

    const fromIsQuarter = isQuarterToken(normFrom);
    const toIsQuarter = isQuarterToken(normTo);

    const concreteFrom = fromIsQuarter ? fromQtrToDT(normFrom) : fromDate;
    const concreteTo = toIsQuarter
      ? toQtrToDT(normTo)
      : toDate === ''
      ? concreteFrom
      : toDate;

    if (rebateProgram === '-1' && allRebateProgram === false) {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'rebateProgram' && item.field !== 'resultNotFound'
      );
      localErr.push({
        field: 'rebateProgram',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    }
    if (!fromDate?.trim()) {
      localErr.push({
        field: 'fromDate',
        errorType: 'formDateRequired',
        message: constantMessageData.INVALID_DATE_FORMAT,
      });
    } else {
      if (!fromIsQuarter) {
        if (
          validDate(new Date(concreteFrom)) === false ||
          !concreteFrom?.includes('/')
        ) {
          localErr.push({
            field: 'fromDate',
            errorType: 'InvalidDate',
            message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
          });
        }
      }
    }
    if (toDate?.length > 0) {
      if (!toIsQuarter) {
        if (
          validDate(new Date(concreteTo)) === false ||
          !concreteTo?.includes('/')
        ) {
          localErr.push({
          field: 'toDate',
          errorType: 'InvalidDate',
            message: constantMessageData.INVALID_DATE_FORMAT,
          });
        }
      }
      if (
        concreteTo &&
        concreteFrom &&
        compareTwoDatesGreaterThanOrEqual(new Date(concreteTo), concreteFrom)
      ) {
        localErr.push({
          field: 'fromDate>toDate',
          errorType: 'fromDate>toDate',
          message: constantMessageData.TO_DATE_CANT_BE_LESS_THAN_FROM,
        });
      }
    }

    if (
      !onDoubleClick &&
      (manufacturerSelectedID === '' || manufacturerSelectedID === undefined)
    ) {
      localErr.push({
        field: 'resultNotFound',
        errorType: 'resultNotFound',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }
    dispatch(handleErrorMessagesCRS([...new Set(localErr)]));
    let tempIndexes = '';
    if (onDoubleClick) {
      manufacturerList.forEach((item, index) => {
        if (
          selectedRowOnDoubleClick &&
          selectedRowOnDoubleClick[0]?.mfgId === item.mfgId
        ) {
          tempIndexes = index;
        }
      });
    }
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    setToDate(toDate === '' ? fromDate : toDate);
    dispatch(
      setSearchInput({
        fromDateValue: fromDate,
        toDateValue: toDate === '' ? fromDate : toDate,
        selectedPlanType: planType,
        rebateProgramValue: rebateProgram,
        rebateProgramName,
        rebateProgrameName,
        manufacturerSelectedID: onDoubleClick
          ? selectedRowOnDoubleClick[0]?.mfgId
          : manufacturerSelectedID,
        manufacturerSelectedName: onDoubleClick
          ? selectedRowOnDoubleClick[0]?.mfgName
          : manufacturerSelectedName,
        selectedRowIndexValue: onDoubleClick ? tempIndexes : selectedRowIndex,
        allRebateProgram,
        isAllManufacturersSelected,
        scrollDownManufacturers,
        searchScreenVar: {
          rebateProgramValue: rebateProgram,
          selectedPlanType: planType,
          fromDateValue: fromDate,
          toDateValue: toDate === '' ? fromDate : toDate,
          allRebateProgram,
          rebateProgrameName,
          isAllManufacturersSelected,
          scrollDownManufacturers,
        },
      })
    );
    const effectiveFrom = concreteFrom;
    const effectiveToFinal = toDate === '' ? concreteFrom : concreteTo;
    if (errorMessagesFromRedux?.length === 0 && reportType == 'Detail') {
      dispatch(setCashReceiptSummaryGrid([]));
      setSearchClicked(true);
      dispatch(dispatchReportType(reportType));
      dispatch(
        getResultGridCashSummary({
          startDate: effectiveFrom,
          endDate: effectiveToFinal,
          mfg: onDoubleClick
            ? selectedRowOnDoubleClick[0]?.mfgId
            : manufacturerSelectedID,
          asRpc: allRebateProgram ? 'ALL' : rebateProgram,
        })
      );
    } else if (
      errorMessagesFromRedux?.length === 0 &&
      reportType == 'Summary'
    ) {
      dispatch(setCashReceiptSummaryGrid([]));
      setSearchClicked(true);
      dispatch(dispatchReportType(reportType));
      dispatch(
        getResultGridNonMatCashSummary({
          startDate: effectiveFrom,
          endDate: effectiveToFinal,
          mfg: onDoubleClick
            ? selectedRowOnDoubleClick[0]?.mfgId
            : manufacturerSelectedID,
          asRpc: allRebateProgram ? 'ALL' : rebateProgram,
        })
      );
    }
    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */
    if (errorMessagesFromRedux.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };
  // hading On blur event on filed level

  const cellClickedListener = (e) => {
    dispatch(
      handleErrorMessagesCRS([
        ...new Set(
          errorMessagesFromRedux?.filter(
            (item) => item.field !== 'resultNotFound'
          )
        ),
      ])
    );
    setManufacturerSelectedID([e?.data]);
    handleSearchClick(null, true, [e?.data]);
  };
  if (
    isSearchClicked &&
    searchResult &&
    searchResult.length > 0 &&
    reportType == 'Detail'
  ) {
    setSearchClicked(false);
    redirectURLLink(
      '/dispCashReceiptSummary',
      'Display Cash Receipt Summary',
      props.history
    );

    dispatch(clearReduxForFilterAndSort('/dispCashReceiptSummary'));
  } else if (
    isSearchClicked &&
    searchResult &&
    searchResult.length > 0 &&
    reportType == 'Summary'
  ) {
    setSearchClicked(false);
    redirectURLLink(
      '/dispCashReceiptSummary',
      'Display Cash Receipt Summary',
      props.history
    );

    dispatch(clearReduxForFilterAndSort('/dispCashReceiptSummary'));
  }
  // Clear the toast error
  React.useEffect(() => {
    dispatch(handleErrorMessagesCRS([]));
  }, [
    rebateProgram,
    radioList,
    fromDate,
    toDate,
    reportType,
    allRebateProgram,
    rebateProgramName,
    isAllManufacturersSelected,
    planType,
  ]);
    const [gridApi, setGridApi] = React.useState(null);
    const onGridReady = (params) => {
      setGridApi(params.api);
    };
    React.useEffect(() => {
      if (!gridApi || manufacturerList === 0) return;
      const selectedRows = gridApi.getSelectedRows();
      if (selectedRows.length > 0) return;
      const firstNode = gridApi.getDisplayedRowAtIndex(0);
      if (firstNode) {
        firstNode.setSelected(true);
        onSelectionChanged({ api: gridApi });
      }
    }, [gridApi, manufacturerList]);

  return (
    <div className='tabs-container'>
      <Spinner load={isLoading} />
      <DisplayErrorMessages
        errorMessages={[
          ...new Set(
            errorMessagesFromRedux?.length > 0
              ? _.map(errorMessagesFromRedux, (l) => l.message)
              : []
          ),
        ]}
      />

      {!fullScreenView && (
        <>
          <CustomSeparator
            parent1='State Reports'
            parent2='Cash Receipt Summary'
          />
          <div className='tab-body'>
            <div className='row mb-3'>
              <div className='col-4 ml-3'>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={allRebateProgram}
                      color='primary'
                      name='allRebateProgram'
                      data-testid='allRebateProgram'
                      onBlur={() => {}}
                      onChange={() => {
                        setAllRebateProgram(!allRebateProgram);
                        const tempRadioList = radioList.map((item) => {
                          return { ...item, disabled: !allRebateProgram };
                        });
                        setRadioList(tempRadioList);
                        dispatch(
                          refreshCashReceiptSummary({
                            ...searchScreenObj,
                            allRebateProgram: !allRebateProgram,
                          })
                        );
                        dispatch(
                          handleErrorMessagesCRS([
                            ...new Set(
                              errorMessagesFromRedux?.filter(
                                (item) =>
                                  item.field !== 'rebateProgram' &&
                                  item.field !== 'resultNotFound'
                              )
                            ),
                          ])
                        );
                      }}
                    />
                  }
                  label='All Rebate Programs'
                />
              </div>
              <div className='col-4'>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isAllManufacturersSelected}
                      color='primary'
                      name='allManufacturers'
                      data-testid='allmanufacturers'
                      // onBlur={(e) => {
                      //   handleOnblurEvent('manufacturer', e.target.value);
                      // }}
                      onChange={(e) => {
                        setIsAllManufacturersSelected(
                          !isAllManufacturersSelected
                        );

                        setScrollDownManufacturers(!scrollDownManufacturers);
                        if (!isAllManufacturersSelected) {
                          setManufacturerSelectedID('ALL');
                        } else {
                          setManufacturerSelectedID('');
                        }

                        const elem = document.getElementById('abc11');
                        if (elem && scrollDownManufacturers) {
                          setTimeout(() => {
                            elem.scrollIntoView();
                          }, 1000);
                        }
                        dispatch(
                          refreshCashReceiptSummary({
                            ...searchScreenObj,
                            isAllManufacturersSelected:
                              !isAllManufacturersSelected,
                          })
                        );
                        dispatch(
                          handleErrorMessagesCRS([
                            ...new Set(
                              errorMessagesFromRedux?.filter(
                                (item) => item.field !== 'resultNotFound'
                              )
                            ),
                          ])
                        );
                      }}
                    />
                  }
                  label='All Manufacturers'
                />
              </div>
            </div>
            <div className='row'>
              <div className='col-4 frr-two-col-radio'>
                <RadioGroupComponent
                  data-testid='cash-receipt-summary-by-radio-btn-plan'
                  id='filter-plan-by-radio-btn-action'
                  labelName='Plan Type'
                  required={false}
                  optionList={radioList || []}
                  defaultValue={planType}
                  filterAction={(value) => {
                    setPlanType(value);
                    setRebateProgram('-1');
                    handleOnChangeEvent(value, 'planTypeCd');
                  }}
                  className='log-batch-filter-radio frr-checkInvoiceRadio'
                />
              </div>
              <div className='col-4'>
                <fieldset className='custom-fieldset'>
                  <legend className='same-font-family'>
                    Rebate Program <span className='mandatory'>*</span>
                  </legend>
                  <div className='form-wrapper p-0'>
                    <div className='mui-custom-form with-select field-xl no-lbl'>
                      <TextField
                        name='rebateProgram'
                        id='rebate_program'
                        label='Rebate Program'
                        data-testid='text-field-for-rebate-program'
                        fullWidth
                        select
                        disabled={searchScreenObj?.allRebateProgram}
                        required
                        inputProps={{ maxLength: 11, id: 'rebate_program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        className={
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'rebateProgram'
                                  ? 'mandate-fields'
                                  : null
                              )
                            : null
                        }
                        onBlur={(e) => {
                          handleOnblurEvent('rebateProgram', e.target.value);
                        }}
                        onChange={(e) => {
                          handleOnChangeEvent(e.target.value, 'rebateProgram');
                          setRebateProgram(e.target.value);
                          setRebateProgramName(e.target.value);
                        }}
                        value={rebateProgram}
                        error={
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'rebateProgram' ? l.message : null
                              )
                            : null
                        }
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'rebateProgram' ? l.message : null
                              )
                            : null
                        }
                      >
                        <MenuItem
                          key=''
                          value='-1'
                          className='frr-dropdown-blank-item'
                        />
                        {selectList?.length > 0
                          ? selectList.map((item) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className='col-4'>
                <Fieldset label='Deposit Date/Quarter Range'>
                  <div className='form-wrapper p-0 mt-n3'>
                    <div className='mui-custom-form input-md field-xl'>
                      <Grid container spacing={2} alignItems='center'>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label='From Date/Quarter'
                            id='FromDate'
                            placeholder=''
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 10, id: 'FromDate' }}
                            data-testid='reqCashReceipt-from'
                            required
                            name='From'
                            value={fromDate}
                            error={
                              errorMessagesFromRedux?.filter(
                                (error) =>
                                  error.field === 'fromDate' ||
                                  error.field === 'fromDate>toDate'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            className={
                              errorMessagesFromRedux?.filter(
                                (error) =>
                                  error.field === 'fromDate' ||
                                  error.field === 'fromDate>toDate'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            onBlur={(e) =>
                              handleOnblurEvent('fromDate', e.target.value)
                            }
                            onChange={(e) => {
                              const { value } = e.target;
                              setFromDate(value.toUpperCase());
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label='To Date/Quarter'
                            id='toDatereq'
                            placeholder=''
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 10, id: 'toDatereq' }}
                            data-testid='reqCashReceipt-to'
                            name='to'
                            value={toDate}
                            onBlur={(e) => {
                              if (e.target?.value?.length > 0) {
                                handleOnblurEvent('toDate', e.target.value);
                              }
                            }}
                            onChange={(e) => {
                              setToDate(e.target.value.toUpperCase());
                              setErrorList([
                                ...errorMessagesFromRedux.filter(
                                  (error) =>
                                    error.field !== 'toDate' &&
                                    error.field !== 'fromDate>toDate'
                                ),
                              ]);
                            }}
                            error={
                              errorMessagesFromRedux?.filter(
                                (error) =>
                                  error.field === 'toDate' ||
                                  error.field === 'fromDate>toDate'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            className='mandate-fields'
                          />
                        </Grid>
                        <Grid xs={12} md={12}>
                          <div
                            className=' Mui-error Mui-required'
                            style={{
                              padding: '0px 10px',
                              fontSize: 12,
                              fontWeight: 600,
                              color: 'red',
                            }}
                          >
                            {
                              errorMessagesFromRedux?.find(
                                (error) =>
                                  error.field === 'fromDate' ||
                                  error.field === 'toDate' ||
                                  error.field === 'fromDate>toDate'
                              )?.message
                            }
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Fieldset>
              </div>
            </div>
            <div className='row' style={{ marginTop: 15 }}>
              <div className='col-4 '>
                <fieldset className='custom-fieldset'>
                  <legend className='same-font-family'>Report Type</legend>
                  <div className='mui-custom-form input-md field-xl'>
                    <div className='sub-radio no-margin'>
                      <FormControl>
                        <RadioGroup row name='Report Type' value={reportType}>
                          <FormControlLabel
                            value='Detail'
                            control={<Radio />}
                            label='All Drugs'
                            data-testid='All_Drugs'
                            name='Detail'
                            onChange={(e) => setReportType(e.target.value)}
                          />
                          <FormControlLabel
                            value='Summary'
                            data-testid='Include_Mat_Drugs'
                            control={<Radio />}
                            label='Include MAT Drugs'
                            onChange={(e) => setReportType(e.target.value)}
                            name='Summary'
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className='btn-wrapper col-8' tabIndex={0}>
                <Button
                  onClick={handleSearchClick}
                  data-testid='ReqCashreceipt-click-searchbtn'
                  className='btn btn-success btn-search float-right'
                >
                  <SVGComponent iconName='Icon-search' /> Search
                </Button>
              </div>
            </div>
          </div>
        </>
      )}
      <div className='row' id='abc11'>
        {!isAllManufacturersSelected && (
          <div className='col-12 unallocated'>
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              cellClickedListener={cellClickedListener}
              helpMessage='* On Double Click of Results, system should navigate to Detail page'
              selectRowIndex={selectedRowIndexValue}
              rowData={manufacturerList || []}
              gridCall={onGridReady}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              columnDefs={AllManufacturer}
              rowSelection='single'
              rowMultiSelectWithClick
              data-testid='onEditingStopped'
              fileName='Manufacturer List'
              enterMovesDown
              suppressCellFocus
              singleClickEdit
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 30) {
                    return (
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='labeler-tooltip'>{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
              exportFile
              hideColumnsInPdf
            />
          </div>
        )}
      </div>
    </div>
  );
}
